import { Country } from '@core/enums/country.enum';

export const CountryName = {
  [Country.Usa]: 'USA',
  [Country.Mexico]: 'MEXICO',
};
